function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/* jshint esversion: 8 */
import { DropdownBuilder } from "./Helpers/DropdownBuilder";
import { ErrorBuilder } from "./Helpers/ErrorBuilder";
import { FormManager } from "./Helpers/FormManager";
import { TextFormatter } from "./Helpers/TextFormatter";
import { HouseholdApiService } from "./Services/HouseholdApiService";
import { UserService } from "./Services/UserService";
import { LookupApiService } from "./Services/LookupApiService";
import { PledgeCampaignApiService } from "./Services/PledgeCampaignApiService";
import { ComponentBase } from "./Shared/ComponentBase";
import { Configuration } from "./Shared/Configuration";
import { I18N } from "./Shared/I18n";
import { NumberUtils } from "./Helpers/NumberUtils";
import { DateTimeFormatter } from "./Helpers/DateTimeFormatter";
export var MppPledgeCampaign = /*#__PURE__*/function (_ComponentBase) {
  _inherits(MppPledgeCampaign, _ComponentBase);

  var _super = _createSuper(MppPledgeCampaign);

  function MppPledgeCampaign() {
    var _this;

    _classCallCheck(this, MppPledgeCampaign);

    _this = _super.call(this);
    var config = new Configuration();
    _this._appRoot = config.GetAppRoot();
    _this._dateFormatter = new DateTimeFormatter();
    return _this;
  }

  _createClass(MppPledgeCampaign, [{
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(name, oldValue, newValue) {
      console.log("Attribute changed!", "".concat(name, " changed from ").concat(oldValue, " to ").concat(newValue));

      if (!!this._$pledgeCampaignWrapper) {
        this.loadAttributes();
        this.LoadPledgeCampaign(this.i18n);
      }
    }
  }, {
    key: "loadAttributes",
    value: function loadAttributes() {
      this.pledgeCampaignID = this.getAttribute("pledgecampaignid") || "3";
      this.pledgeEmailTemplate = this.getAttribute("pledgeemailtemplate") || "528";
      this.suggestedAmounts = this.getAttribute("suggestedamounts");
    } // istanbul ignore next

  }, {
    key: "createI18N",
    value: function createI18N() {
      return new I18N(MppPledgeCampaign.WidgetDetails.tag);
    } // istanbul ignore next

  }, {
    key: "getPledgeCampaignApiService",
    value: function getPledgeCampaignApiService(i18n) {
      return new PledgeCampaignApiService();
    }
  }, {
    key: "connectedCallback",
    value: function () {
      var _connectedCallback = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var i18n;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return this.createI18N();

              case 3:
                i18n = _context.sent;
                _context.next = 10;
                break;

              case 6:
                _context.prev = 6;
                _context.t0 = _context["catch"](0);

                if (_context.t0.toString().startsWith("TypeError")) {
                  this._root.innerHTML = "Unable to connect.  Please check Permitted URLs.";
                } else {
                  this._root.innerHTML = "".concat(_context.t0);
                }

                return _context.abrupt("return");

              case 10:
                this.i18n = i18n;
                this.userInfo = null; // Load attributes

                this.loadAttributes();

                this._initHTMLElements(i18n); // Services


                this._pledgeCampaignService = this.getPledgeCampaignApiService();
                this._lookupService = new LookupApiService(); // Load Pledge Campaign

                this.LoadPledgeCampaign(this.i18n); // Load Frequency Data

                this.LoadFrequencyData(this.i18n); // Login Listener verify with Contact Info

                this.VerifyLogin(this.i18n); // Wire-up event listeners:

                this.BindEventListeners(this.i18n);

              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 6]]);
      }));

      function connectedCallback() {
        return _connectedCallback.apply(this, arguments);
      }

      return connectedCallback;
    }() // istanbul ignore next

  }, {
    key: "_initHTMLElements",
    value: function _initHTMLElements(i18n) {
      this._root.innerHTML = "\n\t\t\t<link href=\"".concat(this._appRoot, "/Content/mppw-widgetstyles.css\" rel=\"stylesheet\" type=\"text/css\" />\n\t\t\t<div class=\"mppw-component-container mpp-pledge-campaign\">\n\t\t\t\t<div id=\"emptyContainer\"></div>\n\t\t\t\t<div id=\"pledgeCampaignWrapper\"></div>\n\t\t\t\t<div id=\"alertContainer\"></div>\n\t\t\t</div>\n\t\t"); // Selectors

      this._$emptyContainer = this._root.querySelector("#emptyContainer");
      this._$pledgeCampaignWrapper = this._root.querySelector("#pledgeCampaignWrapper");
      this._$alertContainer = this._root.querySelector("#alertContainer"); // Templates

      this._$emptyContainer.innerHTML +=  `<i class="mppw-spinner"></i>` ;
      this._$pledgeCampaignWrapper.innerHTML =  `<div id="pledgeCampaignDetails"></div><form id="pledgeForm"><h2>${i18n.createPledgeTitle}</h2><h3>${i18n.pledgeDetailsTitle}</h3><input type="hidden" name="PledgeCampaignID" value="${this.pledgeCampaignID}"/> <input type="hidden" name="PledgeEmailTemplateId" value="${this.pledgeEmailTemplate}"/> <input type="hidden" name="InstallmentsPlanned" id="InstallmentsPlanned" value="0"/> <input type="hidden" name="InstallmentsPerYear" id="InstallmentsPerYear" value="0"/> <input type="hidden" name="ContactId" id="ContactID" value="0"/><div class="form--row"><div class="form--col" id="colPledgeAmountButton"><div class="form--row toggle--btn-wrapper" id="pledgeAmountButtonWrapper"><input type="button" class="mppw-btn secondary mr-5 toggle--btn" value="$30"/> <input type="button" class="mppw-btn secondary mr-5 toggle--btn" value="$50"/> <input type="button" class="mppw-btn secondary mr-5 toggle--btn" value="$100"/></div></div><div class="form--col"><div class="mppw-form-field mppw-form-field__static-container"><input type="number" id="InstallmentAmount" name="InstallmentAmount" class="mppw-form-field__control" required=""/> <label class="mppw-form-field__label" for="InstallmentAmount">${i18n.pledgeAmountLabel}*</label></div></div></div><div class="form--row"><div class="form--col"><div class="mppw-form-field mppw-form-field__static-container"><select class="mppw-form-field__control" id="Frequency" name="Frequency" value="" required=""></select> <label class="mppw-form-field__label">${i18n.frequencyLabel}*</label></div></div><div class="form--col"><div class="mppw-form-field"><input type="date" id="FirstInstallmentDate" name="FirstInstallmentDate" class="mppw-form-field__control" placeholder="mm/dd/yyyy" required data-invalid-message="" min="" max=""> <label class="mppw-form-field__label" for="FirstInstallmentDate">${i18n.pledgeStartDateLabel}*</label></div></div><div class="form--col"><div class="mppw-form-field"><input type="date" id="LastInstallmentDate" name="LastInstallmentDate" class="mppw-form-field__control" placeholder="mm/dd/yyyy" required data-invalid-message="" min="" max=""> <label class="mppw-form-field__label" for="LastInstallmentDate">${i18n.pledgeEndDateLabel}*</label></div></div></div><div class="form--row"><input type="hidden" id="TotalPledge" name="TotalPledge"/> <strong>${i18n.totalPledgeLabel}:&nbsp;</strong> <span id="TotalPledgeValue">$0.00</span></div><div id="makePledgeAsWrapper"><h3>${i18n.personalDetailsTitle}</h3><div class="form--row"><div class="form--col"><div class="mppw-form-field mppw-form-field__static-container"><select class="mppw-form-field__control" id="applyAs" value="0"><option value="0">${i18n.blankFormLabel}</option></select> <label class="mppw-form-field__label">${i18n.makePledgeAsLabel}...</label></div></div></div></div><div id="contactBlankForm"><h3>${i18n.contactTitle}</h3><div class="form--row"><div class="form--col"><div class="mppw-form-field"><input type="text" id="FirstName" name="FirstName" class="mppw-form-field__control" required="" data-required-message="First Name is required please"/> <label class="mppw-form-field__label" for="FirstName">${i18n.firstNameLabel}*</label></div></div><div class="form--col"><div class="mppw-form-field"><input type="text" id="LastName" name="LastName" class="mppw-form-field__control" required="" data-required-message="Last Name is required please"/> <label class="mppw-form-field__label" for="LastName">${i18n.lastNameLabel}*</label></div></div></div><div class="form--row"><div class="form--col"><div class="mppw-form-field"><input type="email" id="Email" name="Email" class="mppw-form-field__control" required="" data-required-message="Email is required please"> <label class="mppw-form-field__label" for="Email">${i18n.emailLabel}*</label></div></div><div class="form--col"><div class="mppw-form-field"><input type="tel" id="MobilePhoneNumber" name="MobilePhoneNumber" class="mppw-form-field__control" maxlength="50"> <label class="mppw-form-field__label" for="MobilePhoneNumber">${i18n.mobilePhoneLabel}</label></div></div></div></div><div class="mppw-right form--footer form--row"><div class="form--col"></div><div class="form--col"><input type="submit" class="mppw-btn primary submit--btn" id="createPledge" value="${i18n.createPledgeButtonLabel}"/></div></div></form>` ; // Selectors from Template (Form)

      this._$loginButton = this._root.querySelector('#loginButton');
      this._$colPledgeAmountButton = this._root.querySelector("#colPledgeAmountButton");
      this._$pledgeAmountButtonWrapper = this._root.querySelector("#pledgeAmountButtonWrapper");
      this._$pledgeAmountToggleButtons = this._$pledgeAmountButtonWrapper.querySelectorAll('.toggle--btn');
      this._$pledgeForm = this._root.querySelector('#pledgeForm');
      this._$makePledgeAsWrapper = this._root.querySelector('#makePledgeAsWrapper');
      this._$applyAs = this._root.querySelector('#applyAs');
      this._$contactId = this._root.querySelector('#ContactID');
      this._$contactBlankForm = this._root.querySelector('#contactBlankForm');
      this._$frequencyDropdown = this._root.querySelector('#Frequency');
      this._$installmentAmount = this._root.querySelector('#InstallmentAmount');
      this._$firstInstallmentDate = this._root.querySelector('#FirstInstallmentDate');
      this._$lastInstallmentDate = this._root.querySelector('#LastInstallmentDate');
      this._$totalPledge = this._root.querySelector('#TotalPledge');
      this._$firstName = this._root.querySelector('#FirstName');
      this._$lastName = this._root.querySelector('#LastName');
      this._$email = this._root.querySelector('#Email');
      this._$totalPledgeDisplay = this._root.querySelector('#TotalPledgeValue');
      this._$installmentsPlanned = this._root.querySelector('#InstallmentsPlanned');
      this._$installmentsPerYear = this._root.querySelector('#InstallmentsPerYear'); // Selectors (Pledge Details)

      this._$pledgeCampaignDetails = this._root.querySelector('#pledgeCampaignDetails'); // Initially hide form

      this._$pledgeForm.style.display = "none";
    }
  }, {
    key: "_justDate",
    value: function _justDate(datetime) {
      if (!!datetime) {
        return new Date(datetime).toISOString().split('T')[0];
      }

      return "";
    }
  }, {
    key: "LoadPledgeCampaign",
    value: function LoadPledgeCampaign(i18n) {
      var _this2 = this;

      return this._pledgeCampaignService.GetCampaign(this.pledgeCampaignID).then(function (pledgeCampaignResponse) {
        // Show form
        _this2._$pledgeForm.style.display = ""; // Clear any previous alerts

        ErrorBuilder.ClearAllAlerts(_this2._$alertContainer);
        var photo = pledgeCampaignResponse.photo,
            title = pledgeCampaignResponse.title,
            description = pledgeCampaignResponse.description,
            campaignGoal = pledgeCampaignResponse.campaignGoal,
            pledged = pledgeCampaignResponse.pledged,
            received = pledgeCampaignResponse.received,
            installmentAmount = pledgeCampaignResponse.installmentAmount,
            campaignStartDate = pledgeCampaignResponse.campaignStartDate,
            campaignEndDate = pledgeCampaignResponse.campaignEndDate,
            allowOnlinePledge = pledgeCampaignResponse.allowOnlinePledge,
            pledgeBeyondEndDate = pledgeCampaignResponse.pledgeBeyondEndDate,
            userHasAlreadyPledged = pledgeCampaignResponse.userHasAlreadyPledged,
            thankYouMessage = pledgeCampaignResponse.thankYouMessage; // variables used in mpp-pledge-campaign-details.html

        var PLEDGE_CAMPAIGN_PHOTO = photo && photo;
        var PLEDGE_CAMPAIGN_TITLE = title && title || 'No campaign title found';
        var PLEDGE_CAMPAIGN_DESCRIPTION = description && new TextFormatter(description).addLineBreaks() || 'No campaign description found';
        var PLEDGE_CAMPAIGN_PLEDGED = NumberUtils.toCurrencyString(pledged);
        var PLEDGE_CAMPAIGN_GOAL = NumberUtils.toCurrencyString(campaignGoal);
        var PLEDGE_CAMPAIGN_PLEDGED_PERCENTAGE = pledged / campaignGoal * 100;
        var PLEDGE_CAMPAIGN_RECEIVED_PERCENTAGE = received / campaignGoal * 100;
        var PLEDGE_CAMPAIGN_PLEDGED_PERCENTAGE_VALUE = Number(PLEDGE_CAMPAIGN_PLEDGED_PERCENTAGE).toLocaleString();
        var PLEDGE_CAMPAIGN_RECEIVED_PERCENTAGE_VALUE = Number(PLEDGE_CAMPAIGN_RECEIVED_PERCENTAGE).toLocaleString();
        _this2._onlineThankYouMessage = thankYouMessage;
        _this2._pledgeBeyondEndDate = pledgeBeyondEndDate;
        _this2._pledgeStartDate = _this2._justDate(campaignStartDate);
        _this2._pledgeEndDate = _this2._justDate(campaignEndDate);

        _this2.PrefillDates(_this2._pledgeStartDate, _this2._pledgeEndDate);

        _this2._$pledgeCampaignDetails.innerHTML =  `<div class="mpp-innerpage"><div class="mpp-card--header"><img id="photo" class="${PLEDGE_CAMPAIGN_PHOTO == null ? 'hidden' : 'mpp-pledge-campaign--photo'}" src="${PLEDGE_CAMPAIGN_PHOTO}"/></div><h1 id="title">${PLEDGE_CAMPAIGN_TITLE}</h1><p id="description">${PLEDGE_CAMPAIGN_DESCRIPTION}</p><h2>${i18n.progressTitle}</h2><div class="progress--container"><h4 class="progress--subtitle">${PLEDGE_CAMPAIGN_PLEDGED} ${i18n.pledgedOfLabel} ${PLEDGE_CAMPAIGN_GOAL} ${i18n.goalLabel}</h4><svg width="100%" height="19"><defs><linearGradient id="gradient"><stop offset="0%" stop-color="#1b88b0"></stop><stop offset="100%" stop-color="#1fb5ac"></stop></linearGradient></defs><g><rect class="background" y="2" height="15" rx="4" ry="4" fill="#efefef" width="100%"></rect><rect class="pledged" y="2" height="15" rx="4" ry="4" fill="url(#gradient)" width="${PLEDGE_CAMPAIGN_PLEDGED_PERCENTAGE > 100 ? 100 : PLEDGE_CAMPAIGN_PLEDGED_PERCENTAGE}%"></rect><rect class="received" x="${PLEDGE_CAMPAIGN_RECEIVED_PERCENTAGE > 100 ? 100 : PLEDGE_CAMPAIGN_RECEIVED_PERCENTAGE}%" fill="#000" width="2" height="19"></rect></g></svg><div class="mpp-innerpage"><p class="mpp-card--description"><span class="progress-legend progress-legend--received"></span>${PLEDGE_CAMPAIGN_RECEIVED_PERCENTAGE_VALUE}% ${i18n.receivedLabel} <span class="progress-legend progress-legend--pledged"></span>${PLEDGE_CAMPAIGN_PLEDGED_PERCENTAGE_VALUE}% ${i18n.pledgedLabel}</p></div></div></div>` ; // hide pledge form if now allowed online or campaign end is not null and less than todays date

        var hideFormBasedOnEndDate = campaignEndDate !== null && new Date().getTime() > new Date(campaignEndDate).getTime();

        if (allowOnlinePledge === false || hideFormBasedOnEndDate) {
          _this2._$pledgeForm.style.display = "none";
          ErrorBuilder.RenderAlert(_this2._$alertContainer, 'warning', i18n.notAcceptingPledgesMessage);
        } // display warning if user has already pledged


        if (userHasAlreadyPledged) {
          ErrorBuilder.RenderAlert(_this2._$alertContainer, 'warning', i18n.userHasAlreadyPledgedMessage);
        } // assign suggested amounts attribute


        _this2.SetSuggestedAmounts();
      })["catch"](function (error) {
        // Log/display error
        console.error('[mpp-pledge-campaign.js]: LoadPledgeCampaign Error: ', error);

        if (error.status === 404) {
          console.error('[mpp-pledge-campaign.js]: Pledge Campaign Not Found');
        }
      })["finally"](function () {
        // Function call completed
        _this2._$emptyContainer.innerHTML = "";
      });
    }
  }, {
    key: "SetSuggestedAmounts",
    value: function SetSuggestedAmounts() {
      var _this3 = this;

      if (this.suggestedAmounts === null || this.suggestedAmounts === "") {
        this.suggestedAmounts = "30,50,100";
      } //start out with hiding the button div, and hide each individual button


      this._$colPledgeAmountButton.style.display = "none";

      this._$pledgeAmountToggleButtons.forEach(function (b) {
        b.style.display = "none";
      });

      if (this.suggestedAmounts !== "" && this.suggestedAmounts !== "null") {
        var suggestedAmountsArr = this.suggestedAmounts.split(',');
        suggestedAmountsArr.map(function (amount, i) {
          if (i >= _this3._$pledgeAmountToggleButtons.length) {
            return;
          }

          _this3._$pledgeAmountToggleButtons[i].value = '$' + amount;

          _this3._$pledgeAmountToggleButtons[i].classList.remove('active'); // if any of the numbers are above zero, show that button and show the button column


          if (Number(amount) > 0) {
            _this3._$pledgeAmountToggleButtons[i].style.display = "";
            _this3._$colPledgeAmountButton.style.display = "";
          }
        });
      }
    }
  }, {
    key: "_getStartOrToday",
    value: function _getStartOrToday(datetime) {
      datetime = new Date(datetime);
      return this._justDate(new Date(Math.max(new Date(), datetime)));
    }
  }, {
    key: "_getDatePartOrFormat",
    value: function _getDatePartOrFormat(datetime) {
      if (!datetime || isNaN(Date.parse(datetime))) {
        return "yyyy-mm-dd";
      }

      var inputDate = new Date(datetime);
      var today = new Date();
      inputDate.setHours(0, 0, 0, 0);
      today.setHours(0, 0, 0, 0);

      if (inputDate >= today) {
        return this._justDate(inputDate);
      }

      return "yyyy-mm-dd";
    }
  }, {
    key: "PrefillDates",
    value: function PrefillDates(startDate, endDate) {
      var minDate = this._getStartOrToday(startDate);

      var lastDateValue = this._getDatePartOrFormat(endDate);

      var effectiveEndDate = this._pledgeBeyondEndDate ? "" : endDate;

      var maxDate = this._getDatePartOrFormat(effectiveEndDate);

      this._$firstInstallmentDate.setAttribute('min', minDate);

      this._$firstInstallmentDate.setAttribute('max', maxDate);

      this._$firstInstallmentDate.setAttribute('value', minDate);

      this._$lastInstallmentDate.setAttribute('min', minDate);

      this._$lastInstallmentDate.setAttribute('max', maxDate);

      this._$lastInstallmentDate.setAttribute('value', lastDateValue);
    }
  }, {
    key: "LoadFrequencyData",
    value: function LoadFrequencyData(i18n) {
      var _this4 = this;

      this._pledgeCampaignService.GetFrequencyData().then(function (frequencyResponse) {
        DropdownBuilder.LoadDropdown(_this4._$frequencyDropdown, frequencyResponse, i18n.frequencyLabel);
      })["catch"](function (error) {
        // Log/display error
        console.error('[mpp-pledge-campaign.js]: LoadFrequencyData Error: ', error);
      })["finally"](function () {// Function call completed
      });
    } // istanbul ignore next

  }, {
    key: "getHouseholdApiService",
    value: function getHouseholdApiService() {
      return new HouseholdApiService();
    }
  }, {
    key: "VerifyLogin",
    value: function VerifyLogin(i18n) {
      var _this5 = this;

      UserService.GetCurrentUser().then(function (userInfo) {
        _this5._getHouseholdMembers(i18n, userInfo);
      }, function () {
        // no cached contactInfo
        _this5._$makePledgeAsWrapper.style.display = "none";

        _this5.ShowContactBlankForm();

        _this5._$contactId.value = "0";
      });
    }
  }, {
    key: "_getHouseholdMembers",
    value: function _getHouseholdMembers(i18n, userInfo) {
      var _this6 = this;

      var householdService = this.getHouseholdApiService();
      householdService.GetHouseholdMembers().then(function (members) {
        if (!!members && members.length > 0) {
          var allMembers = members.map(function (member) {
            return {
              id: member.contactId,
              value: member.displayName
            };
          });
          DropdownBuilder.LoadDropdown(_this6._$applyAs, allMembers, i18n.blankFormLabel);
          _this6._$applyAs.value = userInfo.contactId;
          _this6._$contactId.value = userInfo.contactId;
          _this6.userInfo = userInfo.user;

          _this6.HideContactBlankForm();
        }
      });
    }
  }, {
    key: "BindEventListeners",
    value: function BindEventListeners(i18n) {
      var _this7 = this;

      // submit pledge form
      var pledgeForm = new FormManager(this._$pledgeForm);

      this._$pledgeForm.addEventListener("submit", function (e) {
        e.preventDefault();

        if (pledgeForm.IsValid()) {
          if (_this7.PastCampaignEndDate(_this7._$lastInstallmentDate.value, _this7._pledgeEndDate)) {
            _this7.DisplayErrorPastCampaignEndDate();
          } else {
            var formData = new FormData(_this7._$pledgeForm);

            if (!formData.get("ContactId")) {
              formData.set("ContactId", 0);
            }

            _this7.AddNotesToFormData(formData);

            _this7._savePledge(formData, pledgeForm, i18n);
          }
        } else {
          _this7._$alertContainer.innerHTML = '';
          ErrorBuilder.RenderAlert(_this7._$alertContainer, 'warning', i18n.pledgeFormWarningMessage);
        }
      });

      this._$applyAs.addEventListener("change", function () {
        ErrorBuilder.ClearAllAlerts(_this7._$alertContainer);
        var makePledgeAsValue = _this7._$applyAs.value; // toggle contact form show contact fields if blank form

        if (!!makePledgeAsValue) {
          _this7.HideContactBlankForm();

          _this7._$contactId.value = makePledgeAsValue; // verify if user has pledged and provide warning

          _this7._hasPledged(makePledgeAsValue, i18n);
        } else {
          _this7._$contactId.value = "0";
          _this7._$alertContainer.innerHTML = '';

          _this7.ShowContactBlankForm();
        }
      }); // add active class to clicked button


      var _iterator = _createForOfIteratorHelper(this._$pledgeAmountToggleButtons),
          _step;

      try {
        var _loop = function _loop() {
          var toggleButton = _step.value;
          toggleButton.addEventListener("click", function (e) {
            e.preventDefault();

            var pledgeAmountSelectedButton = _this7._$pledgeAmountButtonWrapper.querySelector('.toggle--btn.active');

            if (!!pledgeAmountSelectedButton) {
              pledgeAmountSelectedButton.classList.remove('active');
            }

            toggleButton.classList.add('active');
            _this7._$installmentAmount.value = toggleButton.value.slice(1);

            _this7.CalculateTotalPledge();
          });
        };

        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          _loop();
        } // filling input will reset active classes

      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this._$installmentAmount.addEventListener("keydown", function () {
        var pledgeAmountSelectedButton = _this7._$pledgeAmountButtonWrapper.querySelector('.toggle--btn.active');

        if (!!pledgeAmountSelectedButton) {
          pledgeAmountSelectedButton.classList.remove('active');
        }
      }); // pledgeDetails to calculate totalPledge


      this._$installmentAmount.addEventListener("change", function () {
        return _this7.CalculateTotalPledge();
      });

      this._$frequencyDropdown.addEventListener("change", function () {
        return _this7.CalculateTotalPledge();
      });

      this._$firstInstallmentDate && this._$firstInstallmentDate.addEventListener("change", function () {
        return _this7.CalculateTotalPledge();
      });
      this._$lastInstallmentDate && this._$lastInstallmentDate.addEventListener("change", function () {
        return _this7.CalculateTotalPledge();
      });
    }
  }, {
    key: "_hasPledged",
    value: function _hasPledged(makePledgeAsValue, i18n) {
      var _this8 = this;

      return this._pledgeCampaignService.HasPledged(this.pledgeCampaignID, makePledgeAsValue).then(function (response) {
        if (response) {
          ErrorBuilder.RenderAlert(_this8._$alertContainer, 'warning', i18n.userHasAlreadyPledgedMessage);
        } else {
          _this8._$alertContainer.innerHTML = '';
        }
      })["catch"](function (error) {
        console.error(error);
        _this8._$alertContainer.innerHTML = '';
        ErrorBuilder.RenderAlert(_this8._$alertContainer, 'danger', 'pledgeCampaignService.HasPledged() inquiry has failed');
      });
    }
  }, {
    key: "_savePledge",
    value: function _savePledge(formData, pledgeForm, i18n) {
      var _this9 = this;

      this._$alertContainer.innerHTML = '';
      return this._pledgeCampaignService.SavePledge(formData).then(function (response) {
        var _this9$_onlineThankYo;

        pledgeForm.Reset();

        _this9.SetSuggestedAmounts();

        _this9._$totalPledge.value = 0;
        _this9._$totalPledgeDisplay.innerHTML = NumberUtils.toCurrencyString(0);

        _this9.PrefillDates(_this9._pledgeStartDate, _this9._pledgeEndDate);

        var thankYouMessage = ((_this9$_onlineThankYo = _this9._onlineThankYouMessage) === null || _this9$_onlineThankYo === void 0 ? void 0 : _this9$_onlineThankYo.trim()) || i18n.pledgeFormSuccessMessage;
        ErrorBuilder.RenderAlert(_this9._$alertContainer, 'success', thankYouMessage);
      })["catch"](function (error) {
        ErrorBuilder.RenderHandler(_this9._$alertContainer, 'danger', error.details);
        console.error(error);
      });
    }
  }, {
    key: "AddNotesToFormData",
    value: function AddNotesToFormData(formData) {
      var firstName = formData.get('FirstName');
      var lastName = formData.get('LastName');
      var email = formData.get('Email');
      var mobilePhoneNumber = formData.get('MobilePhoneNumber');
      var notes = "First Name: ".concat(firstName, "\nLastName: ").concat(lastName, "\nEmail: ").concat(email, "\nPhone: ").concat(mobilePhoneNumber);
      formData.set('Notes', notes);
    }
  }, {
    key: "CheckStartDateAndEndDate",
    value: function CheckStartDateAndEndDate(startDate, endDate) {
      var sd = startDate !== "" ? new Date(startDate) : new Date();
      var ed = endDate !== "" ? new Date(endDate) : new Date();

      if (ed < sd) {
        var _ref = [ed, sd];
        sd = _ref[0];
        ed = _ref[1];
      }

      return [sd, ed];
    }
  }, {
    key: "WeeksBetweenDates",
    value: function WeeksBetweenDates(startDate, endDate) {
      var _this$CheckStartDateA = this.CheckStartDateAndEndDate(startDate, endDate),
          _this$CheckStartDateA2 = _slicedToArray(_this$CheckStartDateA, 2),
          sd = _this$CheckStartDateA2[0],
          ed = _this$CheckStartDateA2[1];

      var WEEK = 7 * 24 * 60 * 60 * 1000;
      return Math.floor((ed - sd) / WEEK) + 1;
    }
  }, {
    key: "MonthsBetweenDates",
    value: function MonthsBetweenDates(startDate, endDate) {
      var _this$CheckStartDateA3 = this.CheckStartDateAndEndDate(startDate, endDate),
          _this$CheckStartDateA4 = _slicedToArray(_this$CheckStartDateA3, 2),
          sd = _this$CheckStartDateA4[0],
          ed = _this$CheckStartDateA4[1];

      var months = this._dateFormatter.GetTotalMonthsBetweenDates(sd, ed);

      return months;
    }
  }, {
    key: "YearsBetweenDates",
    value: function YearsBetweenDates(startDate, endDate) {
      var _this$CheckStartDateA5 = this.CheckStartDateAndEndDate(startDate, endDate),
          _this$CheckStartDateA6 = _slicedToArray(_this$CheckStartDateA5, 2),
          sd = _this$CheckStartDateA6[0],
          ed = _this$CheckStartDateA6[1];

      var years = this._dateFormatter.YearDiff(sd, ed);

      return years;
    }
  }, {
    key: "UseOneTimePledge",
    value: function UseOneTimePledge(amount) {
      this._$totalPledge.value = amount;
      this._$installmentsPlanned.value = 1;
      this._$installmentsPerYear.value = 1;
    }
  }, {
    key: "CalculateTotalPledge",
    value: function CalculateTotalPledge() {
      // Total Pledge: Calculated based on the Amount, First Installment Date, Frequency and End Date.
      var installmentAmount = !!this._$installmentAmount.value ? parseFloat(this._$installmentAmount.value.replaceAll(",", "")).toFixed(2) : 0;
      var frequency = this._$frequencyDropdown.value || 1;
      var firstInstallmentDate = this._$firstInstallmentDate.value;
      var lastInstallmentDate = this._$lastInstallmentDate.value;

      if (!lastInstallmentDate) {
        this.UseOneTimePledge(installmentAmount);
      } else {
        switch (parseInt(frequency)) {
          case 1:
            // one-time pledge
            this.UseOneTimePledge(installmentAmount);
            break;

          case 2:
            // annually
            var numberOfYears = this.YearsBetweenDates(firstInstallmentDate, lastInstallmentDate);

            if (numberOfYears < 1) {
              numberOfYears = 1;
            }

            this._$totalPledge.value = parseFloat(installmentAmount * numberOfYears).toFixed(2);
            this._$installmentsPlanned.value = numberOfYears;
            this._$installmentsPerYear.value = 1;
            break;

          case 12:
            // monthly
            var numberOfMonths = this.MonthsBetweenDates(firstInstallmentDate, lastInstallmentDate);
            this._$totalPledge.value = parseFloat(installmentAmount * numberOfMonths).toFixed(2);
            this._$installmentsPlanned.value = numberOfMonths;

            if (numberOfMonths <= 12) {
              this._$installmentsPerYear.value = numberOfMonths;
            } else {
              this._$installmentsPerYear.value = 12;
            }

            break;

          case 24:
            // twice per month
            var twicePerMonthCount = this.MonthsBetweenDates(firstInstallmentDate, lastInstallmentDate) * 2;
            this._$totalPledge.value = parseFloat(installmentAmount * twicePerMonthCount).toFixed(2);
            this._$installmentsPlanned.value = twicePerMonthCount;

            if (twicePerMonthCount <= 24) {
              this._$installmentsPerYear.value = twicePerMonthCount;
            } else {
              this._$installmentsPerYear.value = 24;
            }

            break;

          case 26:
            // every other week
            var everyOtherWeekCount = Math.floor(this.WeeksBetweenDates(firstInstallmentDate, lastInstallmentDate) / 2);
            this._$totalPledge.value = parseFloat(installmentAmount * everyOtherWeekCount).toFixed(2);
            this._$installmentsPlanned.value = everyOtherWeekCount;

            if (everyOtherWeekCount <= 26) {
              this._$installmentsPerYear.value = everyOtherWeekCount;
            } else {
              this._$installmentsPerYear.value = 26;
            }

            break;

          case 52:
            // weekly
            var weeklyCount = this.WeeksBetweenDates(firstInstallmentDate, lastInstallmentDate);
            this._$totalPledge.value = parseFloat(installmentAmount * weeklyCount).toFixed(2);
            this._$installmentsPlanned.value = weeklyCount;

            if (weeklyCount <= 52) {
              this._$installmentsPerYear.value = weeklyCount;
            } else {
              this._$installmentsPerYear.value = 52;
            }

            break;

          default:
            this._$totalPledge.value = 0;
            this._$installmentsPlanned.value = 0;
            this._$installmentsPerYear.value = 0;
            break;
        }
      }

      this._$totalPledgeDisplay.innerHTML = NumberUtils.toCurrencyString(this._$totalPledge.value);

      if (this.PastCampaignEndDate(this._$lastInstallmentDate.value, this._pledgeEndDate)) {
        this.DisplayErrorPastCampaignEndDate();
      }
    }
  }, {
    key: "ShowContactBlankForm",
    value: function ShowContactBlankForm() {
      this._$contactBlankForm.style.display = "";

      this._$firstName.setAttribute("required", true);

      this._$lastName.setAttribute("required", true);

      this._$email.setAttribute("required", true);

      this._$contactId.value = "0";
    }
  }, {
    key: "HideContactBlankForm",
    value: function HideContactBlankForm() {
      this._$contactBlankForm.style.display = "none";

      this._$firstName.removeAttribute("required");

      this._$lastName.removeAttribute("required");

      this._$email.removeAttribute("required");
    }
  }, {
    key: "PastCampaignEndDate",
    value: function PastCampaignEndDate(lastInstallmentDate, pledgeEndDate) {
      if (!this._pledgeBeyondEndDate && lastInstallmentDate != null && pledgeEndDate != null) {
        var dateInserted = new Date(lastInstallmentDate);
        var endDate = new Date(pledgeEndDate);

        if (dateInserted > endDate) {
          return true;
        }
      }

      return false;
    }
  }, {
    key: "DisplayErrorPastCampaignEndDate",
    value: function DisplayErrorPastCampaignEndDate() {
      this._$alertContainer.innerHTML = '';
      ErrorBuilder.RenderAlert(this._$alertContainer, 'danger', 'Error: You cannot give past the campaign end date (' + this._dateFormatter.ToShortDateFormatted(this._pledgeEndDate, true) + ')');
    }
  }], [{
    key: "WidgetDetails",
    get: function get() {
      return {
        name: "Make a Pledge",
        tag: "mpp-pledge-campaign",
        configurationItems: [{
          name: "Pledge Campaign ID",
          attribute: "pledgecampaignid",
          description: "Determines which Pledge Campaign will be displayed.",
          required: true,
          type: "foreignkey",
          fkTable: "Pledge_Campaigns",
          fkFilter: "",
          fkSingleName: "Pledge Campaign"
        }, {
          name: "Pledge Email Template",
          attribute: "pledgeemailtemplate",
          description: "Confirmation email sent after an individual has successfully created a Pledge. Valid value: Message ID.",
          required: true,
          type: "foreignkey",
          fkTable: "dp_Communications",
          fkFilter: "",
          fkSingleName: "Email Template"
        }, {
          name: "Suggested Amounts",
          attribute: "suggestedamounts",
          description: "Populates 1-3 buttons with suggested giving amounts. Be sure to include commas to separate each desired amount (Default: 30,50,100). If no suggested amount buttons are desired, please enter a value of “NULL” here.",
          required: false,
          type: "text"
        }]
      };
    }
  }, {
    key: "observedAttributes",
    get: function get() {
      return ["pledgecampaignid", "pledgeemailtemplate", "suggestedamounts"];
    }
  }]);

  return MppPledgeCampaign;
}(ComponentBase);
MppPledgeCampaign.registerComponent(MppPledgeCampaign.WidgetDetails.tag, MppPledgeCampaign);